<template>
  <div>
    <vs-breadcrumb class="mb-6" :items="
   [
     {
       title: '分类',
       url: '/category/list'
     },
     {
       title: '分类列表',
       active: true
     }
   ]"></vs-breadcrumb>

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="list" :noDataText="noDataText"
      :stripe="true">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="gotoNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">创建新分类</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th>操作</vs-th>
        <!-- <vs-th>#</vs-th> -->
        <vs-th>分类名称</vs-th>
        <vs-th>排序</vs-th>
        <vs-th>状态</vs-th>
        <vs-th>Banner</vs-th>
        <vs-th>已关联商品</vs-th>
        <!-- <vs-th>子分类</vs-th> -->
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :key="index" v-for="(tr, index) in data">
            <vs-td>
              <div>
                <a href="javascript:void(0)" @click="editData(tr)" class="mr-1">编辑</a>
                <!-- <a href="javascript:void(0)" @click="delData(tr)">删除</a> -->
              </div>
              <!-- <div class="text-muted">
                创建时间:
                <br /> {{tr.created_at}}
              </div>
              <div class="text-muted">
                更新时间:
                <br /> {{tr.updated_at}}
              </div> -->
            </vs-td>
            <!-- <vs-td>{{tr.id}}</vs-td> -->
            <vs-td><span class="text-bold">{{tr.name}}</span></vs-td>
            <vs-td>{{tr.sort}}</vs-td>
            <vs-td>
              <ul class="con-s">
                <li>
                  <div class="mb-1">{{Number(tr.status) === 1?'可用':'已禁用'}}</div>
                  <vs-switch v-model="tr.status" @input="changeSwitch(tr)" />
                </li>
              </ul>
            </vs-td>
            <vs-td>{{tr.banners_count}}张</vs-td>
            <vs-td>{{tr.goods_count}}个</vs-td>
            <!-- <vs-td>
              <div class="mb-2">
                <a href="javascript:void(0)" class="text-primary" @click="addSub(tr.id)">添加子分类</a>
              </div>
              <vs-table noDataText>
                <template slot="thead">

                  <vs-th width="30%">主标题/子标题</vs-th>
                  <vs-th width="20%">排序</vs-th>
                  <vs-th width="20%">已关联商品</vs-th>
                  <vs-th width="25%">操作</vs-th>
                </template>
                <template>
                  <vs-tr v-for="sub in tr.recommends" :key="sub.id">

                    <vs-td>
                      {{sub.name}}
                      <br />
                      <span class="text-muted">{{sub.sub_title}}</span>
                    </vs-td>
                    <vs-td>{{sub.sort}}</vs-td>
                    <vs-td>
                      <a href="javascript:void(0)" @click="openSubItems(sub)">{{sub.goods_count}}</a></vs-td>
                    <vs-td>
                      <div>
                        <a href="javascript:void(0)" @click="editSubData(sub, tr.id, tr.name)" class="mr-1">编辑</a>
                        <a href="javascript:void(0)" @click="delSubData(sub)">删除</a>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-td> -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup :title="editPopUpTitle" :active.sync="editPopUpActive">
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">分类名称</label>
            <vs-input class="w-full" v-model="item.name" />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">分类排序</label>
            <vs-input class="w-full" v-model="item.sort" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="editConfirm" :disabled="btnDisabled">确认修改</vs-button>
            <vs-button type="border" @click="closePopUp" :disabled="btnDisabled">关闭</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="popUpTitle" :active.sync="subAddPopUpActive">
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">子分类主标题</label>
            <vs-input class="w-full" v-model="subTitle" />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">子分类子标题</label>
            <vs-input class="w-full" v-model="subSlogan" />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">排序</label>
            <vs-input class="w-full" v-model="subSort" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="addSubConfirm" :disabled="btnDisabled">确认添加</vs-button>
            <vs-button type="border" @click="closeSubPopUp" :disabled="btnDisabled">关闭</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="编辑子分类" :active.sync="editSubPopUpActive">
      <div class="mb-3 text-bold">
        编辑 "{{categoryName}}" 下的 "{{subItem.name}}"
      </div>
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">子分类主标题</label>
            <vs-input class="w-full" v-model="subItem.name" />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">子分类子标题</label>
            <vs-input class="w-full" v-model="subItem.sub_title" />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">排序</label>
            <vs-input class="w-full" v-model="subItem.sort" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="editSubConfirm" :disabled="btnDisabled">确认编辑</vs-button>
            <vs-button type="border" @click="closeSubPopUp" :disabled="btnDisabled">关闭</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="删除子分类" :active.sync="delSubPopUpActive">
      <div class="mb-3 text-bold">
        备注: 若子分类下添加了关联的商品, 删除时会同时删除商品的关联关系,
        确认删除子分类: "{{subName}}"?
      </div>
      <div class>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="delSubConfirm" :disabled="btnDisabled">确认删除</vs-button>
            <vs-button type="border" @click="closeSubPopUp" :disabled="btnDisabled">关闭</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="关联的商品" :active.sync="subItemsPopUpActive">
      <div class="">
        <template v-if="sub.groups.length > 0">
          <div v-for="group in sub.groups" :key="group.group">
            <div class="text-bold">
              分组{{group.group}}
            </div>
            <div class="mt-3">
              <vs-table ref="table" pagination :max-items="groupItemsPerPage" :data="group.items" noDataText="暂无关联的商品">
                <template slot="thead">
                  <vs-th width="20%">商品图片</vs-th>
                  <vs-th>商品名称/状态</vs-th>
                  <vs-th>价格</vs-th>

                </template>
                <template slot-scope="{data}">
                  <tbody>
                    <vs-tr :key="index" v-for="(tr, index) in data">
                      <vs-td>
                        <image-item :item="tr.goods">
                        </image-item>
                      </vs-td>
                      <vs-td>

                        {{tr.goods.name}}
                        <br />
                        <span v-if="tr.goods.status === 1" class="text-success">上架中</span>
                        <span v-if="tr.goods.status === 0" class="text-danger">未上架(已下架)</span>

                      </vs-td>
                      <vs-td>{{tr.goods.price}} <span class="text-muted text-l-t">{{tr.goods.market_price}}</span>
                      </vs-td>

                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </template>
        <template v-else>

          <div class="mt-3" v-if="newGroupShow">
            <div class="vx-row mb-4">
              <div class="vx-col w-full">
                <label class="mb-5">分组1</label>
              </div>
            </div>
            <div class="vx-row mb-5">
              <div class="vx-col w-full">
                <label class="mb-5"></label>
                <vs-input class="w-full" v-model="subItem.sub_title" />
              </div>
            </div>
            <div class="vx-row mb-5">
              <div class="vx-col w-full">
                <label class="mb-5">排序</label>
                <vs-input class="w-full" v-model="subItem.sort" />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button class="mr-3" @click="editSubConfirm" :disabled="btnDisabled">确认添加</vs-button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </vs-popup>
  </div>
</template>
<script>
  import categoryRepo from '@/repo/category'
  import vSelect from 'vue-select'
  import ImageItem from './components/ImageItem'
  export default {
    components: {
      'v-select': vSelect,
      ImageItem
    },
    data() {
      return {
        list: [],
        itemsPerPage: 20,
        groupItemsPerPage: 3,
        noDataText: '',
        editPopUpTitle: '编辑分类',
        editPopUpActive: false,
        item: {
          name: '',
          sort: ''
        },
        subItem: {
          id: 0,
          name: '',
          sub_title: '',
          sort: ''
        },
        isShowMsg: false,
        msg: '',
        btnDisabled: false,
        subAddPopUpActive: false,
        subTitle: '',
        subSlogan: '',
        subSort: 1,
        popUpTitle: '添加子分类',
        categoryId: 0,
        editSubPopUpActive: false,
        categoryName: '',
        delSubPopUpActive: false,
        subId: '',
        subName: '',
        subItemsPopUpActive: false,
        sub: {
          groups: []
        },
        newGroupShow: false,
        toggleNewGroupBtnLabel: '添加新分组'
      }
    },
    mounted() {
      this.getCategoryList()
      this.noDataText = '加载中...'
    },
    methods: {
      gotoNewData: function () {
        this.$router.push({
          path: '/category/create'
        })
      },
      //获取分类列表
      getCategoryList: function () {
        categoryRepo.list((error, data) => {
          this.noDataText = ''
          if (data.code === 0) {
            const categoryList = data.data

            this.list = categoryList
          }
        })
      },

      delData: function (item) {

      },

      editData: function (item) {

        this.item = item
        this.editPopUpActive = true
      },

      editConfirm: function () {
        this.btnDisabled = true

        categoryRepo.update(this.item, (error, data) => {

          this.btnDisabled = false
          if (error) {
            this.openNotify('编辑分类出错')
          }
          if (data.code !== 0) {
            this.openNotify('编辑分类出错')
          } else {
            this.openNotify(data.msg, 'success')
            this.getCategoryList()
            this.editPopUpActive = false
          }
        })
      },

      closePopUp: function () {
        this.editPopUpActive = false
        this.item = {
          name: '',
          sort: ''
        }
      },

      openNotify: function (msg, color = 'danger') {
        this.$vs.notify({
          position: 'bottom-center',
          color: color,
          title: '操作提示',
          text: msg
        })
      },

      editSubData: function (item, categoryId, categoryName) {

        this.subItem = item
        this.categoryId = categoryId
        this.categoryName = categoryName
        this.editSubPopUpActive = true
      },

      changeSwitch: function (e) {
        //当前修改的item
        //console.log('e:', e)
        let {
          id,
          status
        } = e
        status = status ? 1 : 0
        const statusName = status === 1 ? '启用' : '禁用'
        categoryRepo.updateStatus(id, status, (error, data) => {

          if (error) {
            this.openNotify('更新分类状态失败')
          }
          if (data.code === 0) {
            this.openNotify(`分类${statusName}成功`, 'success')
          }
        })
      },

      addSub: function (id) {
        this.categoryId = id
        this.subAddPopUpActive = true
      },

      addSubConfirm: function () {
        this.btnDisabled = true
        const addData = {
          categoryId: this.categoryId,
          subTitle: this.subTitle,
          subSlogan: this.subSlogan,
          subSort: this.subSort
        }
        categoryRepo.addSub(addData, (error, data) => {
          this.btnDisabled = false

          if (data.code === 0) {
            this.openNotify(data.msg, 'success')
            this.getCategoryList()
          } else {
            this.openNotify(data.msg)
          }
        })
      },

      closeSubPopUp: function () {
        this.subAddPopUpActive = false
        this.editSubPopUpActive = false
        this.delSubPopUpActive = false
      },

      //提交子分类修改
      editSubConfirm: function () {
        this.btnDisabled = true
        const subId = this.subItem.id
        const subName = this.subItem.name
        const subTitle = this.subItem.sub_title
        const subSort = this.subItem.sort === '' ? 0 : this.subItem.sort
        if (subName === '') {
          this.openNotify('子分类名称不能为空')
        } else if (subTitle === '') {
          this.openNotify('子分类广告语不能为空')
        } else {
          console.log(1)
          const params = {
            categoryId: this.categoryId,
            subId: subId,
            subName: subName,
            subTitle: subTitle,
            subSort: subSort
          }
          categoryRepo.editSub(params, (error, data) => {
            this.btnDisabled = false

            if (error) {
              this.openNotify('编辑子分类基本信息失败')
            }
            if (data.code === 0) {
              this.openNotify(data.msg, 'success')
              this.editSubPopUpActive = false
              this.getCategoryList()
            } else {
              this.openNotify(data.msg)
            }
          })
        }
      },

      delSubData: function (sub) {

        this.subId = sub.id
        this.subName = sub.name
        this.delSubPopUpActive = true
      },

      delSubConfirm: function () {
        this.btnDisabled = true
        categoryRepo.delSub(this.subId, (error, data) => {
          this.btnDisabled = false

          if (error) {
            this.openNotify('删除子分类失败')
          }
          if (data.code === 0) {
            this.openNotify(data.msg, 'success')
            this.getCategoryList()
          } else {
            this.openNotify(data.msg)
          }
        })
      },

      openSubItems: function (sub) {

        this.subItemsPopUpActive = true
        this.sub = sub
      },

      toggleNewGroup: function () {
        this.newGroupShow = this.newGroupShow ? false : true
        this.toggleNewGroupBtnLabel = this.newGroupShow ? '关闭添加新分组' : '添加新分组'
      }

    }
  }

</script>
<style scoped>
  .a-hover {
    cursor: pointer;
  }

  .text-muted {
    color: #999;
  }

  .text-bold {
    font-weight: bold;
  }

  .text-l-t {
    text-decoration: line-through;
  }

</style>
